@if (myReservations.length > 0) {
<ul class="bookings-list">
  @for (res of myReservations; track res) {
  <li class="booking-item" [routerLink]="['booking/view', res.id]">
    <div class="booking-icon"><em class="fal fa-box"></em></div>
    <div class="booking-content">
      <span class="booking-time">{{ res.start | date : 'EEEE d MMM' }}</span>
      <p class="booking-name">{{ res.eventName }}</p>
    </div>
  </li>
  }
</ul>
} @else {
<div class="empty-state">
  <div class="empty-state-icon"><em class="fal fa-box"></em></div>
  <p class="empty-state-text">Aucune commande de matériel à venir</p>
</div>
}
<a class="widget-viewall" [routerLink]="['/booking/my']">Voir toutes mes commandes →</a>
